import { AttributeModel } from "src/models";

export const sortAttributesByOrder = (
  attributes: AttributeModel[],
  field: "order" | "order_gallery" = "order",
): AttributeModel[] => attributes.sort((current, next) => current[field] - next[field]);
